var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"g_layout"}},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"headers"}},[_c('tm-bar')],1),_c('div',{attrs:{"id":"content-window"}},[_c('router-view')],1),_c('div',{attrs:{"id":"footers"}},[_c('g-footer')],1)])]),_c('g-sidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }